const PRODUCTION_URL =
  process.env.REACT_APP_API_URL ||
  "https://t-global-backend-v3-1050393382437.us-central1.run.app";

export const getApiUrl = () => {
  if (
    window.location.hostname.includes("firebaseapp.com") ||
    window.location.hostname.includes("web.app") ||
    window.location.hostname === "oomiitech.com"
  ) {
    return PRODUCTION_URL;
  }
  return "http://localhost:5000";
  // return "https://t-global-backend-v3-testing-competitor-1050393382437.us-central1.run.app";
};

export default getApiUrl;
